import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#bootcamp", label: "Bootcamp" },
  { href: "#framework", label: "BUILD Framework" },
  { href: "#build", label: "What You'll Build" },
  { href: "#agenda", label: "Agenda" },
  { href: "#pricing", label: "Pricing" },
  { href: "#faq", label: "FAQ" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`fixed top-0 inset-x-0 z-50 transition-all ${scrolled ? "backdrop-blur-xl bg-[#06080F]/85 border-b border-cyan-500/15" : "bg-transparent"}`}>
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-16 flex items-center justify-between">
        <a href="#top" data-testid="nav-brand-logo" className="flex items-center gap-2 group">
          <img src="https://customer-assets-jai6qajn.emergentagent.net/job_build-framework-27/artifacts/xu1ebv9g_MOOLAH%20LOGO.jpg" alt="Moolah Tech" className="h-9 w-9 rounded-lg object-cover shadow-[0_0_20px_rgba(56,189,248,0.4)]"/>
          <span className="font-bold tracking-tight text-white text-[15px]">MOOLAH <span className="text-cyan-400">TECH</span></span>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {links.map(l => (
            <a key={l.href} href={l.href} className="text-[13px] text-slate-300 hover:text-white transition-colors">{l.label}</a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a href="/admin" data-testid="nav-admin-link" className="text-[12px] text-slate-500 hover:text-cyan-300 font-mono uppercase tracking-widest">Admin</a>
          <a href="#register" data-testid="nav-reserve-btn" className="cta-primary text-sm">Reserve My Seat</a>
        </div>

        <button className="lg:hidden text-white p-2" onClick={() => setOpen(v => !v)} aria-label="Menu" data-testid="nav-mobile-toggle">
          {open ? <X className="w-6 h-6"/> : <Menu className="w-6 h-6"/>}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#06080F]/95 backdrop-blur-xl border-b border-cyan-500/15">
          <div className="px-5 py-6 flex flex-col gap-4">
            {links.map(l => (
              <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-slate-200 text-base">{l.label}</a>
            ))}
            <a href="/admin" className="text-slate-500 text-sm font-mono tracking-widest uppercase">Admin</a>
            <a href="#register" onClick={() => setOpen(false)} className="cta-primary text-center text-sm">Reserve My Seat</a>
          </div>
        </div>
      )}
    </header>
  );
}
